import { Button, Input, Table, Tabs } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { PartnerContext } from "../PartnerOutlet";
import AxiosInstance from "../../../../AxiosInstance";
import { amountFormat } from "../../../../utils";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash"; // Importing debounce from lodash
import PartnerAllReferView from "./PartnerAllReferView";

export default function PartnerReferView() {
  const partnerContext = useContext(PartnerContext);
  const [loading, setLoading] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  const [status, setStatus] = useState("ACTIVE");
  const navigate = useNavigate();
  var [dataSource, setDataSource] = useState([]);
  const [searchTerm, setSearchTerm] = useState(""); // State for search term

  const onChange = (key) => {
    console.log(key);
  };

  useEffect(() => {
    getTableData(0, searchTerm); // Fetch data when search term changes or on mount
  }, []); // Re-run the effect when the search term changes

  const getTableData = async (skip, searchTerm) => {
    const url =
      partnerContext.viewMode === "INVESTOR"
        ? `partner/investor/list?take=10&skip=${skip}`
        : `partner/referral?take=10&skip=${skip}&role=${partnerContext.viewMode}`;

    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        setDataSource(data?.data ?? []);
        setPaginationMetaData(data.paginationMetaData ?? {});
        setLoading(false);
      })
      .catch((err) => {});
  };

  const columns = [
    {
      title: "Refer Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, policy) => moment(policy.createdAt).format("DD/MM/YYYY"),
    },
    {
      title: "Referred User Profile",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Name of User",
      dataIndex: "name",
      key: "name",
      render: (text, policy) => policy["firstName"] + " " + policy["lastName"],
    },
    {
      title: "User Email ID",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "User Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
  ];
  const invColumns = [
    {
      title: "Refer Date",
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      render: (text, policy) => moment(policy.createdAt).format("DD/MM/YYYY"),
    },
    {
      title: "Referred User Profile",
      dataIndex: "role",
      align: "center",
      key: "role",
    },
    {
      title: "Name of Investor",
      dataIndex: "name",
      key: "name",
      render: (text, policy) => policy["firstName"] + " " + policy["lastName"],
    },
    {
      title: "Investor Email ID",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Investor Phone Number",
      dataIndex: "phoneNumber",
      align: "center",
      key: "phoneNumber",
    },
  ];

  const change = (data) => {
    getTableData((data - 1) * 10, searchTerm);
  };

  // Debounced function for search input
  const debouncedSearch = debounce((value) => {
    setSearchTerm(value); // Update the search term state
  }, 500); // Wait for 500ms after the user stops typing

  return (
    <div>
      <div className="d-flex gap-2">
        <div className="mx-2">
          {" "}
          <button
            className="refer-policy-partner-btn"
            onClick={() => {
              navigate("/referpage");
            }}
          >
            <i className="fa-solid fa-share tre_flex-hcenter text-white back-icon "></i>{" "}
            Refer User
          </button>
        </div>
        {/* <Button
         
        >
          Refer User
        </Button> */}
        {/* <Input
          className="col-2"
          name="search"
          allowClear
          placeholder="Type to Search"
          onChange={(e) => debouncedSearch(e.target.value)} // Call debounced search
        /> */}
      </div>
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Referral List" key="1">
          <Table
            bordered={true}
            scroll={{ x: 400 }}
            loading={loading}
            className="table"
            dataSource={[...dataSource]}
            columns={
              partnerContext.viewMode === "INVESTOR" ? invColumns : columns
            }
            pagination={{
              pageSize: 10,
              total: paginationMetaData.count,
              onChange: change,
            }}
          />
        </Tabs.TabPane>

        <Tabs.TabPane tab="All Referrals" key="2">
          <PartnerAllReferView />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}
